import { Nominal } from "@goodfill/nominal";

export type TransactionId = Nominal<"TransactionId">;
export const asTransactionId = (id: string) => id as unknown as TransactionId;

export enum TransactionType {
  Deposit = "Deposit",
  Withdrawal = "Withdrawal",
  Trade = "Trade",
  OrderLock = "OrderLock",
}

export enum TransactionSource {
  Stripe = "Stripe",
  Test = "Test",
}

export const ALL_TRANSACTION_SOURCES = [TransactionSource.Stripe, TransactionSource.Test];
